import React from 'react';
import { Helmet } from 'react-helmet-async';

const BVHelmet = () => (
  <Helmet>
    <link rel="preconnect" href="https://apps.bazaarvoice.com" />
    <link rel="preconnect" href="https://display.ugc.bazaarvoice.com" />
  </Helmet>
);

export default BVHelmet;
